import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { publicAPI } from '../services/api';
import './TeachersMarquee.css';

const TeachersMarquee = () => {
  const { language } = useLanguage();
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarqueeTeachers = async () => {
      try {
        const response = await publicAPI.getMarqueeTeachers();
        setTeachers(response.data.marquee_teachers || []);
      } catch (error) {
        console.error('Failed to fetch marquee teachers:', error);
        setTeachers([
          {
            id: "default-1",
            name: "Ms. Gaby",
            title_en: "English Teacher",
            title_ar: "معلمة إنجليزي",
            image: "https://storage.googleapis.com/msgsndr/1yH5m8o1wurAPKrI3BJm/media/67e1e37f1870f446643a1fcf.png"
          },
          {
            id: "default-2",
            name: "Mr. Brian",
            title_en: "IELTS Trainer",
            title_ar: "مدرب آيلتس",
            image: "https://storage.googleapis.com/msgsndr/1yH5m8o1wurAPKrI3BJm/media/67e1be350fc794a2b9d79bbd.png"
          },
          {
            id: "default-3",
            name: "Ms. Katherine",
            title_en: "Kids English",
            title_ar: "إنجليزي للأطفال",
            image: "https://storage.googleapis.com/msgsndr/1yH5m8o1wurAPKrI3BJm/media/67e1be15afbf86b2240b75b1.jpeg"
          },
          {
            id: "default-4",
            name: "Mr. Jafar",
            title_en: "Level 1 English",
            title_ar: "إنجليزي المستوى الأول",
            image: "https://storage.googleapis.com/msgsndr/1yH5m8o1wurAPKrI3BJm/media/67e1c2c60fc7940d17d7a2ee.png"
          },
          {
            id: "default-5",
            name: "Ms. Layla",
            title_en: "Beginner English Teacher",
            title_ar: "معلمة إنجليزي للمبتدئين",
            image: "https://storage.googleapis.com/msgsndr/1yH5m8o1wurAPKrI3BJm/media/67e1bf48f31f8f7bf9a833e7.png"
          },
          {
            id: "default-6",
            name: "Ms. Henderina",
            title_en: "Business English Instructor",
            title_ar: "مدربة إنجليزي الأعمال",
            image: "https://storage.googleapis.com/msgsndr/1yH5m8o1wurAPKrI3BJm/media/67e1be7f9643c113015e53b8.jpeg"
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchMarqueeTeachers();
  }, []);

  if (loading || teachers.length === 0) {
    return null;
  }

  // Default placeholder image
  const placeholderImage = "https://storage.googleapis.com/msgsndr/1yH5m8o1wurAPKrI3BJm/media/67e1e37f1870f446643a1fcf.png";

  const getImageUrl = (teacher) => {
    if (!teacher.image) return placeholderImage;
    // Handle Base64 data URLs (stored in MongoDB)
    if (teacher.image.startsWith('data:')) return teacher.image;
    // Handle external URLs
    if (teacher.image.startsWith('http')) return teacher.image;
    // Handle relative paths (legacy)
    return `${process.env.REACT_APP_BACKEND_URL}${teacher.image}`;
  };

  const TeacherCard = ({ teacher }) => {
    const [imgError, setImgError] = React.useState(false);
    
    return (
      <div className="marquee-card">
        <img
          src={imgError ? placeholderImage : getImageUrl(teacher)}
          alt={teacher.name}
          onError={() => setImgError(true)}
          loading="lazy"
        />
        <div className="marquee-card-overlay"></div>
        <div className="marquee-card-info">
          <h3>{teacher.name}</h3>
          <p>{language === 'en' ? teacher.title_en : teacher.title_ar}</p>
        </div>
      </div>
    );
  };

  return (
    <section className="marquee-section">
      <div className="marquee-header">
        <h2>{language === 'en' ? 'Our Teachers' : 'معلمونا'}</h2>
        <p>{language === 'en' ? 'Hover to pause' : 'مرر للإيقاف'}</p>
      </div>
      
      <div className="marquee-wrapper">
        <div className="marquee-gradient-left"></div>
        <div className="marquee-gradient-right"></div>
        
        <div className="marquee-content">
          {/* Render enough cards to fill screen and loop */}
          {[...Array(10)].map((_, setIndex) => (
            teachers.map((teacher, idx) => (
              <TeacherCard key={`${setIndex}-${idx}`} teacher={teacher} />
            ))
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeachersMarquee;
